var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21053 22V15.6842H5V13.5789H7.10526V6.21053H8.15789V4.10526H9.21053V3.05263H10.2632V2H14.4737V3.05263H15.5263V4.10526H16.5789V6.21053H17.6316V13.5789H19.7368V15.6842H15.5263V22H13.4211V15.6842H11.3158V22H9.21053ZM13.4211 5.15789V4.10526H11.3158V5.15789H10.2632V7.26316H9.21053V13.5789H10.2632V12.5263H14.4737V13.5789H15.5263V7.26316H14.4737V5.15789H13.4211Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketM);
export default __webpack_public_path__ + "static/media/rocket-m.27770580c59abff602c9151f17031bb0.svg";
export { ForwardRef as ReactComponent };